import { useConfig } from 'config';
import { useRouter } from 'next/router';
import { buildCanonicalUrl } from 'components/seo/canonical/build-canonical-url';

const Canonical = (url: string | null | undefined) => {
  const { frontendUrl } = useConfig();
  const { locale } = useRouter();
  const pageUrl = buildCanonicalUrl({
    host: frontendUrl,
    locale,
    pathname: url,
  });

  return (
    <>
      <link rel="canonical" href={pageUrl} />
      <meta name="og:url" property="og:url" content={pageUrl} />
    </>
  );
};

export default Canonical;
